import { Stack } from '@mui/material';
import ContentBuilderRow from 'domains/core/components/ContentBuilderRow';
import { VoiceContentStateTypes, VoiceText } from '../types';
import Interactions from '../Interactions';
import MessageInputWithMergeTags from '../MessageInputWithMergeTags';
import { setVoiceCallRootMessage } from '../voiceCallActions';

type Props = {
    voiceContentState: VoiceContentStateTypes;
    dispatchVoiceContentAction: React.Dispatch<any>;
    isMessageLoading: boolean;
};

const VoiceCallBuilder = ({ dispatchVoiceContentAction, voiceContentState, isMessageLoading }: Props) => (
    <Stack>
        <ContentBuilderRow
            title="Introduction Message"
            subtitle="This is the message your contact will hear when they pick up. Keep it clear, focused, and engaging to align with your goal."
            content={
                <MessageInputWithMergeTags
                    handleMessageChange={(value: string) =>
                        dispatchVoiceContentAction(setVoiceCallRootMessage([{ text: value, type: 'text' }]))
                    }
                    isMessageLoading={isMessageLoading}
                    message={(voiceContentState.voiceJson.voiceCall.message[0] as VoiceText).text}
                />
            }
        />
        <ContentBuilderRow
            title="Interactions"
            subtitle="Use interactions to share key information, gather input, or prompt the next action."
            content={
                <Interactions
                    interactions={voiceContentState.voiceJson.voiceCall.interactions}
                    dispatchVoiceContentAction={dispatchVoiceContentAction}
                />
            }
        />
    </Stack>
);

export default VoiceCallBuilder;
